import { Observable } from "rxjs";
import {
  BoardSegmentFilter,
  ClosingDetail,
  RonMonitorBoard,
} from "./ron-monitor.models";

export abstract class RonMonitorDataSource {
  abstract getBoard(
    date: Date,
    segment: BoardSegmentFilter
  ): Observable<RonMonitorBoard>;

  abstract getDetail(packageId: number): Observable<ClosingDetail>;
}
